<section *ngIf="selectedView == 'list'">
  <!-- <p-dataTable [value]="deviceList$ | async" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,20]"
    *ngIf="!groupFeature">
    <p-column [sortable]="true" field="icon" header="Status" [style]="{'width':'80px'}"
      styleClass="col-nowrap text-center">
      <ng-template let-col let-data="rowData" pTemplate="body">
        <span class="center">
          <i class="fa {{data.icon}} {{data.status}}" aria-hidden="true"></i>
        </span>
      </ng-template>
    </p-column>
    <p-column [sortable]="true" field="name" header="Name" [style]="{'width':'200px'}" styleClass="col-nowrap ellipsis">
      <ng-template let-col let-data="rowData" pTemplate="body">
        <a [routerLink]="data.routeLink">{{data.name}}</a>
      </ng-template>
    </p-column>
    <p-column [sortable]="true" field="type" header="Type" styleClass="hidden-sm" [style]="{'width':'120px'}">
    </p-column>
    <p-column [sortable]="true" field="desc" header="Description" [style]="{'width':'100%'}" styleClass="desc">
    </p-column>
  </p-dataTable> -->
  <p-table class="deviceTable" [columns]="deviceTable_cols" [value]="deviceList$ | async" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,20]"
    *ngIf="!groupFeature" (sortFunction)="customSort($event)" [customSort]="true" [scrollable]="true">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns; let i= index" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
          {{col.header | translate}} <i *ngIf="i == 8" class="fa fa-info-circle" aria-hidden="true" pTooltip="{{'Recommended Battery Replacement Date' | translate}}" tooltipPosition="bottom"
            tooltipStyleClass="tooltips_gary"></i>
          <p-sortIcon [field]="col.field" *ngIf="i != 3"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr *ngIf="dataLoading">
        <td [hidden]="col.hide" *ngFor="let col of columns" [ngStyle]="{'width.px':(col.width) }">
          <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
        </td>
      </tr>
      <tr *ngIf="!this.isMsp && !dataLoading" [class.disabled]="!this.isMsp && rowData.isExpired ? true : companionAlertitem ? (rowData.protecting ? (rowData.status !== 'offline' ? true : null) : null) : null" [ngClass]="{'trial_block': rowData.isExpired && rowData.canTrial && !this.isMsp, 'companion_block': !rowData.isExpired && companionAlert && rowData.protecting && rowData.status !== 'offline'}">
        <td style="width: 80px" class="nowrap text-center">
          <span class="center">
            <i class="fa {{rowData.icon}} {{rowData.status}}" aria-hidden="true"></i>
          </span>
        </td>
        <td style="width: 150px" class="nowrap ellipsis">
          <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': rowData.hardwarefault.faultLevelColor}" *ngIf="rowData.hardwarefault && rowData.hardwarefault.isHardwareFault"></i>
          <a [routerLink]="rowData.routeLink"  [class.disabled]="rowData.protecting && rowData.status !== 'offline'">{{rowData.name}}</a>
        </td>
        <td style="width: 150px;" class="lock">
          <!-- <i class="fa fa-lock fa-5x" *ngIf="rowData.isExpired && !powerMaster" pTooltip="{{'No valid Plan or trial is available' | translate}}" tooltipPosition="bottom"
            tooltipStyleClass="tooltips_gary"></i> -->
          <i class="fa fa-lock fa-5x" *ngIf="rowData.isExpired && powerMaster" pTooltip="{{'License is expired or no license is assigned to this device' | translate}}" tooltipPosition="bottom"
            tooltipStyleClass="tooltips_gary"></i>

          <button type="button" pButton (click)="displayExpiredDialog(rowData);" label="{{'Locked' | translate}}"
            class="p-button-rounded p-button-secondary" icon="fa fa-lock" *ngIf="rowData.isExpired && !powerMaster && rowData.type !== 'Group' && !rowData.canTrial && !this.isMsp"></button>
          <button type="button" pButton (click)="displayisTrialDialog(rowData);" label="{{'Get Free Trial' | translate}}"
            class="p-button-rounded" icon="fa fa-lock" *ngIf="rowData.isExpired && !powerMaster && rowData.type !== 'Group' && rowData.canTrial && !this.isMsp"></button>
          <button type="button" pButton (click)="routerCompanion();" label="{{'See Companion' | translate}}"
            class="p-button-rounded ui-button-danger" *ngIf="!rowData.isExpired && !powerMaster && rowData.type !== 'Group' && companionAlert && rowData.protecting && rowData.status !== 'offline' && rowData.DisplayDeviceSubType === 'UPS'"></button>
        </td>
        <td style="width: 90px" class="hidden-sm">{{rowData.type}}</td>
        <td style="width: 200px" class="hidden-sm" *ngIf="rowData.Load != '' else nonlode">{{rowData.Load}}</td>
        <ng-template #nonlode>
          <td style="width: 200px" class="hidden-sm">{{rowData.Load}}</td>
        </ng-template>
        <td style="width: 250px" class="hidden-sm">{{rowData.batteryRun}}</td>
        <td style="width: 200px" class="hidden-sm" *ngIf="rowData.batCap != '' else nonbatCap">{{rowData.batCap}}</td>
        <ng-template #nonbatCap>
          <td style="width: 200px" class="hidden-sm">{{rowData.batCap}} %</td>
        </ng-template>
        <td style="width: 180px" class="nowrap">
          <div class="device-rbrd" *ngIf="rowData.type !== 'Group' && rowData.btyReplacement && rowData.btyReplacement.BR_Rc_Date" [ngClass]="{'alert-color': rowData.btyReplacement.expires, 'companion_block': companionAlert && rowData.protecting && rowData.status !== 'offline'}">
            <div class="device-icon" *ngIf="rowData.btyReplacement.expires">
              <i class="fa fa-bell" aria-hidden="true"></i>
            </div>
            <span>{{rowData.btyReplacement.BR_Rc_Date | date: preferenceService.dateFormat}}</span>
          </div>
        </td>
        <!-- <td style="width: 200px" class="">
          <span *ngIf="!rowData.isExpired" [ngClass]="{'alert-color': rowData.trialRemainDay <10}">{{rowData.trialRemainDay}}</span>
        </td> -->
        <td style="width: 150px" class="">
          <i class="fa fa-battery-full {{rowData.BHIStatus}}" aria-hidden="true" *ngIf="rowData.BHIStatus else noData_BHI"></i>
          <ng-template #noData_BHI>
            <div class="fa-stack">
              <i class="fa fa-battery-empty fa-stack-2x"></i>
              <span class="value fa-stack-1x">N/A</span>
            </div>
          </ng-template>
        </td>
        <td style="width: 380px;min-width: 380px" class="desc">{{rowData.desc | translate}}</td>
      </tr>
    </ng-template>
  </p-table>

  <p-treeTable #tt [value]="deviceGroupList" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,20]"
    [columns]="cols" *ngIf="groupFeature" (onPage)="onPageloading($event)">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [ttSortableColumn]="col.field">
          {{col.header | translate}}
          <p-treeTableSortIcon [field]="col.field"></p-treeTableSortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns; let i= index" [ttSortableColumn]="col.field" [ttSortableColumnDisabled]="col.disabled"
          [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
          {{col.header | translate}} <i *ngIf="i == 8" class="fa fa-info-circle" aria-hidden="true" pTooltip="{{'Recommended Battery Replacement Date' | translate}}" tooltipPosition="bottom"
            tooltipStyleClass="tooltips_gary"></i>
          <p-treeTableSortIcon [field]="col.field" *ngIf="i !== 2 && i !== 3 && i !== 5"></p-treeTableSortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
      <tr *ngIf="dataLoading">
        <td [hidden]="col.hide" *ngFor="let col of columns" [ngStyle]="{'width.px':(col.width) }">
          <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
        </td>
      </tr>
      <tr *ngIf="!dataLoading" [class.disabled]="!this.isMsp && rowData.isExpired ? true : companionAlertitem ? (rowData.protecting ? (rowData.status !== 'offline' ? true : null) : null) : null " [ngClass]="{'trial_block': rowData.isExpired && rowData.canTrial && !this.isMsp , 'share_block': rowData.is_shared && rowData.share_status === 0, 'companion_block': !rowData.isExpired && companionAlert && rowData.protecting && rowData.status !== 'offline', 'group_share_block': rowData.is_shared && rowData.share_status === 0 && rowData.type === 'Group'}">
        <td class="nowrap text-center" style="width: 80px;max-width: 80px">
          <span class="center">
            <i class="fa {{rowData.icon}} {{rowData.status}}" aria-hidden="true"></i>
          </span>
        </td>
        <td class="nowrap text-center groupSetting" style="width: 80px;max-width: 80px">
          <span class="center" [hidden]="rowData.type !== 'Group'" *ngIf="!rowData.is_shared">
            <a class="groupLink" (click)="triggerDelete(rowData.gId)" *ngIf="rowData.regionId == null || rowData.EditDevice === 1"><i class="fa fa-trash" aria-hidden="true"></i></a>
            <a class="groupLink edit" (click)="triggerEdit(rowData.gId)" *ngIf="rowData.regionId == null || rowData.EditDevice === 1"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a>
          </span>
        </td>
        <td style="width: 250px;" class="nowrap ellipsis">
          <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
          <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': rowData.hardwarefault.faultLevelColor}" *ngIf="rowData.type !== 'Group' && rowData.hardwarefault &&
            rowData.hardwarefault.isHardwareFault"></i>
          <a [routerLink]="rowData.routeLink" [class.disabled]="rowData.isExpired ? true : companionAlertitem ? (rowData.protecting ? (rowData.status !== 'offline' ? true : null) : null) : null" [ngClass]="{'disabled': rowData.shared}">{{rowData.name}}</a>
        </td>
        <td style="width: 180px;" class="col-lock">
          <!-- <i class="fa fa-lock fa-5x" *ngIf="rowData.isExpired && !powerMaster" pTooltip="{{'No valid Plan or trial is available' | translate}}" tooltipPosition="bottom"
            tooltipStyleClass="tooltips_gary"></i> -->
          <i class="fa fa-lock fa-5x" *ngIf="rowData.isExpired && powerMaster" pTooltip="{{'License is expired or no license is assigned to this device' | translate}}" tooltipPosition="bottom"
            tooltipStyleClass="tooltips_gary"></i>

          <button type="button" pButton (click)="displayExpiredDialog(rowData);" label="{{'Locked' | translate}}"
            class="p-button-rounded p-button-secondary" icon="fa fa-lock" *ngIf="rowData.isExpired && !powerMaster && rowData.type !== 'Group' && !rowData.canTrial && !this.isMsp"></button>
          <button type="button" pButton (click)="displayisTrialDialog(rowData);" label="{{'Get Free Trial' | translate}}"
            class="p-button-rounded" icon="fa fa-lock" *ngIf="rowData.isExpired && !powerMaster && rowData.type !== 'Group' && rowData.canTrial && !this.isMsp"></button>

          <div class="button" *ngIf="rowData.type !== 'Group' && rowData.is_shared && rowData.share_status === 0">
            <p-button icon="pi pi-times" class="p-btn-outline" (click)="rejectShareDevice(rowData);"></p-button>
            <p-button icon="pi pi-check" class="p-btn-fill" (click)="acceptShareDvice(rowData);"></p-button>
          </div>
          <div class="button" *ngIf="rowData.type === 'Group' && rowData.is_shared && rowData.share_status === 0">
            <p-button icon="pi pi-times" class="p-btn-outline" (click)="rejectSharedGroup(rowData);"></p-button>
            <p-button icon="pi pi-check" class="p-btn-fill" (click)="acceptSharedGroup(rowData);"></p-button>
          </div>
          <div class="badge badge-primary" *ngIf="rowData.type !== 'Group' && rowData.is_shared && rowData.share_status === 1">
            <span translate>Shared Device</span>
          </div>
          <div class="badge badge-primary" *ngIf="rowData.type === 'Group' && rowData.is_shared && rowData.share_status === 1">
            <span translate>Shared Group</span>
          </div>
          <div class="button" *ngIf="rowData.type !== 'Group' && companionAlert && rowData.protecting && !rowData.isExpired && !powerMaster && rowData.status !== 'offline'">
            <button type="button" pButton (click)="routerCompanion();" label="{{'See Companion' | translate}}" class="p-button-rounded ui-button-danger" ></button>
          </div>
        </td>
        <td style="width: 90px;" class="hidden-sm">{{rowData.displaysubtype}}</td>
        <!-- <td style="width: 100px" class="hidden-sm" *ngIf="rowData.Load != '' else nonlode">{{rowData.Load}}</td>
        <ng-template #nonlode>
          <td style="width: 100px" class="hidden-sm">{{rowData.Load}}</td>
        </ng-template>
        <td style="width: 150px" class="hidden-sm">{{rowData.batteryRun}}</td>
        <td style="width: 150px" class="hidden-sm">{{rowData.batteryCapacity}}</td>
        <td style="width: 140px" class="col-nowrap">
          <div class="device-rbrd" *ngIf="rowData.type !== 'Group' && rowData.btyReplacement && rowData.btyReplacement.BR_Rc_Date" [ngClass]="{'alert-color': rowData.btyReplacement.expires, 'companion_block': companionAlert && rowData.protecting && rowData.status !== 'offline'}">
            <div class="device-icon" *ngIf="rowData.btyReplacement.expires">
              <i class="fa fa-bell" aria-hidden="true"></i>
            </div>
            <span>{{rowData.btyReplacement.BR_Rc_Date | date: preferenceService.dateFormat}}</span>
          </div>
        </td> -->
        <!-- <td style="width: 200px" class="">
          <span *ngIf="!rowData.isExpired" [ngClass]="{'alert-color': rowData.trialRemainDay <10}">{{rowData.trialRemainDay}}</span>
        </td> -->
        <!-- <td style="width: 100px" class="">
          <i class="fa fa-battery-full {{rowData.BHIStatus}}" aria-hidden="true" *ngIf="rowData.BHIStatus else noData_BHI"></i>
          <ng-template #noData_BHI *ngIf="rowData.Type !== 'Group'">
            <div class="fa-stack">
              <i class="fa fa-battery-empty fa-stack-2x"></i>
              <span class="value fa-stack-1x">N/A</span>
            </div>
          </ng-template>
        </td> -->
        <td style="width: 860px" class="nowrap">
          <div *ngIf="rowData.type !== 'Group'">
            <div class="flex" *ngIf="rowData.subtype === 'UPS' || rowData.subtype === '3-Phase UPS'">
              <div class="flex align" *ngIf="rowData.subtype === 'UPS' && rowData.Load != null">
                <div class="flex align">
                  <div class="weight-bold">{{ rowData.Load }} {{'W' | translate}}</div>
                  <small>{{'Load' | translate}}</small>
                  <div class="divider"></div>
                </div>
              </div>
              <div class="flex align" *ngIf="rowData.subtype === '3-Phase UPS' && rowData?.LoadPctA != null">
                <div class="flex align">
                  <div class="weight-bold">{{rowData.LoadPctA}} %</div>
                  <small>{{'Load-A' | translate}}</small>
                  <div class="divider"></div>
                </div>
              </div>
              <div class="flex align" *ngIf="rowData.subtype === '3-Phase UPS' && rowData?.LoadPctB != null">
                <div class="flex align">
                  <div class="weight-bold">{{rowData.LoadPctB}} %</div>
                  <small>{{'Load-B' | translate}}</small>
                  <div class="divider"></div>
                </div>
              </div>
              <div class="flex align" *ngIf="rowData.subtype === '3-Phase UPS' && rowData?.LoadPctC != null">
                <div class="flex align">
                  <div class="weight-bold">{{rowData.LoadPctC}} %</div>
                  <small>{{'Load-C' | translate}}</small>
                  <div class="divider"></div>
                </div>
              </div>
              <div class="flex align" *ngIf="rowData.subtype === 'UPS' && rowData.SourceType !== SourceType['Gateway'] && rowData?.batteryRun != null">
                <div class="flex align">
                  <div class="weight-bold">{{rowData.batteryRun}} {{'Mins' | translate}}</div>
                  <small>{{'Remaining Runtime' | translate}}</small>
                  <div class="divider"></div>
                </div>
              </div>
              <div class="flex align" *ngIf="rowData?.batteryCapacity != null">
                <div class="flex align">
                  <div class="weight-bold">{{rowData.batteryCapacity}} %</div>
                  <small>{{'Battery Capacity' | translate}}</small>
                  <div class="divider"></div>
                </div>
              </div>
              <div class="device-rbrd flex align" *ngIf="rowData.type !== 'Group' && rowData.SourceType !== SourceType['Gateway'] && rowData.btyReplacement && rowData.btyReplacement.BR_Rc_Date" [ngClass]="{'alert-color': rowData.btyReplacement.expires, 'companion_block': companionAlert && rowData.protecting && rowData.status !== 'offline'}">
                <div class="device-icon" *ngIf="rowData.btyReplacement.expires">
                  <i class="fa fa-bell" aria-hidden="true"></i>
                </div>
                <div class="weight-bold">{{rowData.btyReplacement.BR_Rc_Date | date: preferenceService.dateFormat}}</div>
                <small>RBRD<i class="fa fa-info-circle" aria-hidden="true" pTooltip="{{'Recommended Battery Replacement Date' | translate}}" tooltipPosition="bottom"
                  tooltipStyleClass="tooltips_gary"></i></small>
                <div class="divider"></div>
              </div>
              <div class="flex align" *ngIf="!rowData.hideBHI">
                <i class="fa fa-battery-full {{rowData.BHIStatus}}" aria-hidden="true" *ngIf="rowData.BHIStatus else noData_BHI"></i>
                <ng-template #noData_BHI>
                  <div class="fa-stack">
                    <i class="fa fa-battery-empty fa-stack-2x"></i>
                    <span class="value fa-stack-1x">N/A</span>
                  </div>
                </ng-template>
                <small class="padding-left-4">BHI</small>
              </div>
            </div>
            <div class="flex" *ngIf="rowData.subtype !== 'UPS' || rowData.subtype !== '3-Phase UPS'">
              <div class="flex align" *ngIf="rowData?.Cur != null">
                <div class="flex align">
                  <div class="weight-bold">{{rowData.Cur}} {{'A' | translate}}</div>
                  <small>{{'Current' | translate}}</small>
                  <div class="divider"></div>
                </div>
              </div>
              <div class="flex align" *ngIf="rowData?.Energy != null">
                <div class="flex align">
                  <div class="weight-bold">{{rowData.Energy}} <span>{{'kWh' | translate}}</span></div>
                  <small>{{'Energy' | translate}}</small>
                  <div class="divider"></div>
                </div>
              </div>
              <div class="flex align" *ngIf="rowData?.Power != null">
                <div class="flex align">
                  <div class="weight-bold">{{rowData.Power}} <span>{{'W' | translate}}</span></div>
                  <small translate>Power</small>
                  <div class="divider"></div>
                </div>
              </div>
              <div class="flex align" *ngIf="rowData?.Volt != null">
                <div class="flex align">
                  <div class="weight-bold">{{rowData.Volt}} <span>{{'V' | translate}}</span></div>
                  <small>{{'Voltage' | translate}}</small>
                  <div class="divider"></div>
                </div>
              </div>
              <div class="flex align" *ngIf="rowData?.VoltA != null">
                <div class="flex align">
                  <div class="weight-bold">{{rowData.VoltA}} <span>{{'V' | translate}}</span></div>
                  <small>{{'Voltage-A' | translate}}</small>
                  <div class="divider"></div>
                </div>
              </div>
              <div class="flex align" *ngIf="rowData?.VoltB != null">
                <div class="flex align">
                  <div class="weight-bold">{{rowData.VoltB}} <span>{{'V' | translate}}</span></div>
                  <small>{{'Voltage-B' | translate}}</small>
                  <div class="divider"></div>
                </div>
              </div>
              <div class="flex align" *ngIf="rowData?.VoltC != null">
                <div class="flex align">
                  <div class="weight-bold">{{rowData.VoltC}} <span>{{'V' | translate}}</span></div>
                  <small>{{'Voltage-C' | translate}}</small>
                  <div class="divider"></div>
                </div>
              </div>
              <div class="flex align" *ngIf="rowData?.InVoltA != null">
                <div class="flex align">
                  <div class="weight-bold">{{rowData.InVoltA}} <span>{{'V' | translate}}</span></div>
                  <small>{{'Input Voltage-A' | translate}}</small>
                  <div class="divider"></div>
                </div>
              </div>
              <div class="flex align" *ngIf="rowData?.InVoltB != null">
                <div class="flex align">
                  <div class="weight-bold">{{rowData.InVoltB}} <span>{{'V' | translate}}</span></div>
                  <small>{{'Input Voltage-B' | translate}}</small>
                  <div class="divider"></div>
                </div>
              </div>
            </div>
          </div>
        </td>
        <td class="desc" style="width: 380px;min-width: 380px">{{rowData.desc | translate}}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr *ngFor="let item of dataLoadingView">
        <td *ngIf="dataLoading" class="nowrap text-center" style="width: 80px;max-width: 80px">
          <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
        </td>
        <td *ngIf="dataLoading" class="nowrap text-center groupSetting" style="width: 80px;max-width: 80px">
          <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
        </td>
        <td *ngIf="dataLoading" style="width: 250px;" class="nowrap ellipsis">
          <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
        </td>
        <td *ngIf="dataLoading" style="width: 180px;" class="lock">
          <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
        </td>
        <td *ngIf="dataLoading" style="width: 90px;" class="hidden-sm"><p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton></td>
        <td *ngIf="dataLoading" class="">
          <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
        </td>
        <td *ngIf="dataLoading" class="desc" style="width: 380px;min-width: 380px"><p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton></td>
      </tr>
      <tr *ngIf="!dataLoading">
        <td translate [attr.colspan]="cols.length" *ngIf="selectedTab == '0' || selectedTab == '1' || selectedTab == '3'">No Device found</td>
        <td translate [attr.colspan]="cols.length" *ngIf="selectedTab == '2' || selectedTab == '4'">No Group found</td>
      </tr>
    </ng-template>
  </p-treeTable>
</section>

<app-edit-group></app-edit-group>
<app-delete-group></app-delete-group>
<app-dialog></app-dialog>
